/**
 * Reconciliation Routes
 * ============================================================================
 *
 * Bank-statement reconciliation list + per-batch review. Gated only by
 * authentication; the backend enforces reconciliation:* permissions
 * per endpoint, and the sidebar nav entry is also permission-gated so
 * users without the role don't see the link.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const ReconciliationListPage = lazy(
  () => import('@/features/reconciliation/ui/pages/reconciliation-list-page')
);
const ReconciliationDetailPage = lazy(
  () => import('@/features/reconciliation/ui/pages/reconciliation-detail-page')
);

export const reconciliationRoutes: RouteGroup = {
  name: 'reconciliation',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: { requiresAuth: true },
  routes: [
    {
      path: ROUTE_PATHS.RECONCILIATION,
      component: ReconciliationListPage,
      meta: {
        title: 'common:reconciliation.title',
        showInNav: true,
      },
    },
    {
      path: ROUTE_PATHS.RECONCILIATION_DETAIL,
      component: ReconciliationDetailPage,
      meta: {
        title: 'common:reconciliation.detailTitle',
        parent: ROUTE_PATHS.RECONCILIATION,
      },
    },
  ],
};
